package ai.wagemix.net.models

import com.fsryan.foundation.models.FSStringEnumerated
import kotlinx.serialization.Serializable

/**
 * Types of regression algorithms that can be applied to wage data for projection
 */
@Serializable
enum class WMRegressionType(override val stringValue: String): FSStringEnumerated {
    /**
     * Linear regression using least squares method
     */
    Linear("linear")
}


